import { render, staticRenderFns } from "./StringFacet.vue?vue&type=template&id=38328658&"
import script from "./StringFacet.vue?vue&type=script&lang=js&"
export * from "./StringFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports